import { render, staticRenderFns } from "./SignupPackages.vue?vue&type=template&id=27b7049a"
import script from "./SignupPackages.vue?vue&type=script&lang=js"
export * from "./SignupPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports